import { useNavigate } from "react-router-dom";

import BackIcon from "../../../../assets/svg/BackIcon";

import FbIcon from "../../../../assets/images/facebook-app-symbol.png";
import InstaIcon from "../../../../assets/images/instagram.png";
import TelegramImg from "../../../../assets/images/telegram.png";
import WhatsappContact from "../../../../assets/images/whatsapp-cont-icon.svg";
import ContactImg from "../../../../assets/images/3D-illustration/contact-us-3.png";
import PhoneContact from "../../../../assets/images/phone-cont-icon.svg";
import { useSelector } from "react-redux";
import Footer from "../../../../containers/Footer";
import BeforeLoginFooter from "../../../../containers/BeforeLoginFooter";
import HeaderAfterLogin from "../../../../containers/HeaderAfterLogin";
import Header from "../../../../containers/Header";
import { useEffect } from "react";

const ContactUsBefore = () => {
  const navigate = useNavigate();
  const { appDetails } = useSelector((state) => state.app);
  const { isAuth } = useSelector((state) => state.auth);

  return (
    <div>
      {isAuth ? <HeaderAfterLogin /> : <Header />}

      <main className="main" id="payment_page">
        <div className=" container">
          <div className="pagesHeading">
            <h4>Contact Us</h4>
            <div className="back-link" onClick={() => navigate(-1)}>
              Back <BackIcon />
            </div>
          </div>

          <div className="ContactusPageSection">
            <div className="ContactPart">
              <h5
                className="heading mb-4"
                style={{ textAlign: "center", maxWidth: "380px" }}>
                Reach our customer support team between 10:30 AM – 7:30 PM IST
              </h5>
              <ul>
                <li>
                  <a
                    href={
                      appDetails?.WHATS_APP_URL != ""
                        ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                        : "#"
                    }
                    target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}>
                    <div className="img_box">
                      <img src={WhatsappContact} alt="whatsapp" />
                    </div>
                    <div>
                      <h6>Whatsapp</h6>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href={appDetails.TELEGRAM != "" ? appDetails.TELEGRAM : "#"}
                    target={appDetails.TELEGRAM != "" ? "_blank" : ""}>
                    <div className="img_box">
                      <img src={TelegramImg} alt="telegramImg" />
                    </div>
                    <div>
                      <h6>Telegram</h6>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href={
                      appDetails.INSTATGRAM != "" ? appDetails.INSTATGRAM : "#"
                    }
                    target={appDetails.INSTATGRAM != "" ? "_blank" : ""}>
                    <div className="img_box">
                      <img src={InstaIcon} alt="instaIcon" />
                    </div>
                    <div>
                      <h6>Instagram</h6>
                    </div>
                  </a>
                </li>
                <li>
                  <a
                    href={appDetails.FACEBOOK != "" ? appDetails.FACEBOOK : "#"}
                    target={appDetails.FACEBOOK != "" ? "_blank" : ""}>
                    <div className="img_box">
                      <img src={FbIcon} alt="facebook" />
                    </div>
                    <div>
                      <h6>Facebook</h6>
                    </div>
                  </a>
                </li>
                <li>
                  <a href={`tel:+919650436700`}>
                    <div className="img_box">
                      <img src={PhoneContact} alt="callingIMg" />
                    </div>
                    <div>
                      <h6>Calling</h6>
                    </div>
                  </a>
                </li>
              </ul>
            </div>

            <div className="ContactPart">
              <div className="contact_img">
                <img src={ContactImg} alt="Contact Image" />
              </div>
            </div>
          </div>
        </div>
      </main>

      {isAuth ? <Footer /> : <BeforeLoginFooter />}
    </div>
  );
};

export default ContactUsBefore;
